import { Condition, DetailType, LLPType, ProductStatus, WooStatus } from '../enums';
import { Badge } from './badge';
export interface Product extends ListProduct {
    /**
     * @description : `Optional` property that represents the `Retail Price` for the  `Product`
     */
    retailPrice?: number;
    /**
     * @description : This property will show the `Discount for the Product in Percentage`
     */
    discountPercentage: number;
    /**
     * @description : This property will show the `Sell Price` for non-retail `Product`
     */
    sellPrice: number;
    /**
     * @description : This represents an `Array` the contains `All Images` with this `Product`
     */
    allImages: string[];
    /**
     * @description : Here you can choose the `Product Conditions` from an `Enum`
     */
    condition: Condition;

    /**
     * @description: The specific characteristics of the product
     */
    specifics: string;

    /**
     * @description : This will show some `details of the product` ... like Size , Color , etc
     */
    details: ProductDetails[];

    /**
     * @description : This will show a 'QR Code`
     */
    qrCode: string;
    /**
     * @description : This property will `Describe the Product `
     */
    description: string[];
    /**
     * @description : This will show some information about the delivery for this Product
     */
    shipmentText: string[];
    /**
     * @description : This will show available Rates for buying this Product
     */
    rates: ProductRates;
    /**
     * @description : Here you can find an Array with different products related to this Product
     */
    relatedProducts: ListProduct[];
    /**
     * @description : This represents the `Status` of the `Product` (If its in Stock , Sold or Reserved)
     */
    status: ProductStatus;

    /**
     * @description The status that the product has in woocommerce.
     */
    wooStatus: WooStatus;

    /**
     * @description The categories that the product is part of
     */
    categories: string[];

    /**
     * @description The date when the product was last modified in woo
     */
    dateModifiedInWoo: Date;

    /**
     * @description The html woo description will be used for search
     */
    wooDescription: string;

    /**
     * @description Flag to indicate if the product should be included in landing page carousel
     */
    isForLandingPage: boolean;

    /**
     * @description Flag to indicate if the product should be hidden from all normal searches and filters
     */
    isHidden: boolean;
    shareUrl?: string;
    llp?: {
        numberOfRates: string;
        advance: string;
        plans: LLPPlan[];
    };
}

export interface LLPPlan {
    type: LLPType;
    rates: string;
    amountPerMonth: string;
    finalDate: string;
}

export interface ListProduct extends SmallListProduct {
    /**
     * @description : This is the Product `Sku Code`
     */
    sku: string;

    /**
     * @description : This represents the `Title` of the `product`
     */
    title: string;

    /**
     * @description : This is an Array with Badges
     */
    badges: Badge[];

    /**
     * @description : This will show the `Likes` number of the `product`
     */
    likes: number;

    /**
     * @description It indicates weather the product is in stock or not
     */
    isInStock: boolean;

    /**
     * @description Indicates weather the product is reserved by VIP
     */
    isVipReserved: boolean;
    /**
     * @description Flag to indicate if the product is on sale
     */
    isOnSale: boolean;
}

export interface SmallListProduct {
    /**
     * @description : This represents the `Id` of the product `from relatedProducts property of the Product`
     */
    id?: any;

    /**
     * @description : This represents the `Primary Images of the product`
     */
    primaryImage: string;

    /**
     * @description : This represents  the `Brand` of the `product`
     */
    brand: string;

    isFavorite?: boolean;
}

export interface ProductDetails {
    /**
     * @description : This is the name of the Detail for this product
     */
    name: DetailType;
    /**
     * @description : This is the value of the Detail for this product
     */
    values: string[];
}

export interface ProductRates {
    /**
     * @description : This represents the `advance sum to buy` a product in rates
     */
    advance?: number;
    /**
     * @description : This is the `amount` to pay with `One Rate`
     */
    oneRate?: number;
    /**
     * @description : This is the `amount` to pay with `Two Rate`
     */
    twoRates?: number;
    /**
     * @description : This is the `amount` to pay with `Three Rate`
     */
    threeRates?: number;
}

export interface ListFavorites {
    product: Product;
    id: string;
}
